import {ACTIONS} from '../../actions/nav.actions';

let initialState = {
  selectedCompany: ''
};

export function navReducer(state = initialState, action){
  switch(action.type){
    case ACTIONS.CompanySelected: 
      return {
        ...state,
        selectedCompany: action.payload
      };
    default: 
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/nav/index.js